import type { IntlShape } from 'react-intl';
import type { Tenant } from '../../configuration/types';

export enum TenantType {
    COUNTRY_SPECIFIC = 0,
    EU_TACHOGRAPH = 1,
    UNKNOWN = 2,
}

export const mapTenantToTenantType = (tenant: Tenant | null): TenantType => {
    if (tenant?.startsWith('rio-eu.')) {
        return TenantType.EU_TACHOGRAPH;
    } else if (tenant?.startsWith('rio-brazil.')) {
        return TenantType.COUNTRY_SPECIFIC;
    } else {
        return TenantType.UNKNOWN;
    }
};

export const driverCardOrLicenseIntlMessage = (tenant: Tenant | null, intl: IntlShape) => {
    const tenantType = mapTenantToTenantType(tenant);
    if (tenantType === TenantType.EU_TACHOGRAPH) {
        return intl.formatMessage({ id: 'intl-msg:card' });
    } else if (tenantType === TenantType.COUNTRY_SPECIFIC) {
        return intl.formatMessage({ id: 'intl-msg:license' });
    } else {
        return '';
    }
};
